export enum EventMemberStatusModel {
    Open = 0,
    Accepted = 1,
    Declined = 2,
    Requested = 3,
    Waiting = 4,
    Completed = 5,
    Manual = 6
}